module.exports = __webpack_public_path__ + "static/en-sm-1-c3e6759fec0af4b18674dd0a332eaf1d.png";